import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InvoiceGenerationComponent } from './invoice-generation/invoice-generation.component';
import { RecurringInvoiceComponent } from './recurring-invoice/recurring-invoice.component';
import { BalanceCheckComponent } from './balance-check/balance-check.component';
import { CombinedReportComponent } from './combined-report/combined-report.component';
import { RecurringInvoiceHistoryComponent } from './recurring-invoice-history/recurring-invoice-history.component';
import { OnceOffInvoiceComponent } from './once-off-invoice/once-off-invoice.component';
import { BillingPromotionComponent } from './billing-promotion/billing-promotion.component';
import { StatementReceiptCheckComponent } from './statement-receipt-check/statement-receipt-check.component';
import { PaymentDashboardComponent } from './payment-dashboard/payment-dashboard.component';

const routes: Routes = [
{
  path: 'invoicegeneration',
  component: InvoiceGenerationComponent,
},
{
  path: 'recurringInvoice',
  component: RecurringInvoiceComponent,
},
{
  path: 'balanceCheck',
  component: BalanceCheckComponent,
},
{
  path: 'combinedReport',
  component: CombinedReportComponent,
},
{
  path: 'recurringInvoiceHistory',
  component: RecurringInvoiceHistoryComponent,
},
{
  path: 'onceOffInvoice',
  component: OnceOffInvoiceComponent,
},
{
  path: 'billingPromotion',
  component: BillingPromotionComponent,
},
{
  path: 'statementReceiptCheck',
  component: StatementReceiptCheckComponent,
},
{
  path: 'paymentsDashboard',
  component: PaymentDashboardComponent,
}

  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BillingRoutingModule { }
